import { gql } from "apollo-boost";
import {TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_COURSEOUTLINEREGISTRATION = gql`
  query getCourseOutlineRegistration($id: ID!) {
    getCourseOutlineRegistration(
      id: $id
    ) {
      id subjectCode subjectName teacherCode periodCode
      academicPeriod{
        id periodCode
      }
      courseOutline {
        id
      }
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng creditCalGrade creditDesc
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSections {
        id sectionNo  descriptionLocal descriptionEng studentQty
        vdoSetCode startClassDate learnSpanNo examSpanNo
        vdoSet{
          id code description totalVdoLength
          vdoSetUnits {
            id unitSeq code totalVdoLength status remark
            vdoSetTopics {
              id no nameLocal nameEng vdoLength vdoStreamPath isEnabled
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_COURSEOUTLINEREGISTRATIONS = gql`
  query getCourseOutlineRegistrations {
    getCourseOutlineRegistrations {
      id subjectCode subjectName teacherCode periodCode
      academicPeriod{
        id periodCode
      }
      courseOutline {
        id
      }
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSections {
        id sectionNo  descriptionLocal descriptionEng studentQty
        vdoSetCode startClassDate learnSpanNo examSpanNo
        vdoSet{
          id code description totalVdoLength
          vdoSetUnits {
            id unitSeq code totalVdoLength status remark
            vdoSetTopics {
              id no nameLocal nameEng vdoLength vdoStreamPath isEnabled
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER = gql`
  query getCourseOutlineRegistrationsByFilter(
    $courseOutlineRegistrationFilterInput: CourseOutlineRegistrationFilterInput
  ) {
    getCourseOutlineRegistrationsByFilter(
      courseOutlineRegistrationFilterInput: $courseOutlineRegistrationFilterInput
    ) {
      id subjectCode subjectName teacherCode periodCode
      academicPeriod{
        id periodCode
      }
      courseOutline {
        id
      }
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSections {
        id sectionNo  descriptionLocal descriptionEng studentQty
        vdoSetCode startClassDate learnSpanNo examSpanNo
        vdoSet{
          id code description totalVdoLength
          vdoSetUnits {
            id unitSeq code totalVdoLength status remark
            vdoSetTopics {
              id no nameLocal nameEng vdoLength vdoStreamPath isEnabled
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
        classRoom{
          id
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER_FOR_TABLE = gql`
  query getCourseOutlineRegistrationsByFilter(
    $courseOutlineRegistrationFilterInput: CourseOutlineRegistrationFilterInput
  ) {
    getCourseOutlineRegistrationsByFilter(
      courseOutlineRegistrationFilterInput: $courseOutlineRegistrationFilterInput
    ) {
      id subjectCode subjectName teacherCode periodCode
      subject {
        id code nameLocal nameEng creditCalGrade
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSections {
        id
      }
      courseOutline{
        id
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER_ONLY_COURSEOUTLINE = gql`
  query getCourseOutlineRegistrationsByFilter(
    $courseOutlineRegistrationFilterInput: CourseOutlineRegistrationFilterInput
  ) {
    getCourseOutlineRegistrationsByFilter(
      courseOutlineRegistrationFilterInput: $courseOutlineRegistrationFilterInput
    ) {
      id
      courseOutline{
        id
      }
    }
  }
`;

export const ADD_COURSEOUTLINEREGISTRATION = gql`
  mutation addCourseOutlineRegistration(
    $courseOutlineRegistrationInput: [CourseOutlineRegistrationInput!]
  ) {
    addCourseOutlineRegistration (
      courseOutlineRegistrationInput: $courseOutlineRegistrationInput
    )
      {
        id subjectCode subjectName teacherCode periodCode
        academicPeriod{
          id periodCode
        }
        courseOutline {
          id
        }
        degree {
          id code nameLocal nameEng
        }
        subjectGroup {
          id code nameLocal nameEng
        }
        subject {
          id code nameLocal nameEng
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
        classSections {
          id sectionNo  descriptionLocal descriptionEng studentQty
          vdoSetCode startClassDate learnSpanNo examSpanNo
          vdoSet{
            id code description totalVdoLength
            vdoSetUnits {
              id unitSeq code totalVdoLength status remark
              vdoSetTopics {
                id no nameLocal nameEng vdoLength vdoStreamPath isEnabled
                playbackUrl
                playbackStatus
                videoProvider
                bunnyVideoGuid
                bunnyStatus
              }
            }
          }
        }
      }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const UPDATE_COURSEOUTLINEREGISTRATION = gql`
  mutation updateCourseOutlineRegistration(
    $id: ID!,
    $courseOutlineRegistrationInput: CourseOutlineRegistrationInput!
  ) {
    updateCourseOutlineRegistration (
      id: $id
      courseOutlineRegistrationInput: $courseOutlineRegistrationInput
    ) {
      id subjectCode subjectName teacherCode periodCode
      academicPeriod{
        id periodCode
      }
      courseOutline {
        id
      }
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSections {
        id sectionNo  descriptionLocal descriptionEng studentQty
        vdoSetCode startClassDate learnSpanNo examSpanNo
        vdoSet{
          id code description totalVdoLength
          vdoSetUnits {
            id unitSeq code totalVdoLength status remark
            vdoSetTopics {
              id no nameLocal nameEng vdoLength vdoStreamPath isEnabled
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const UPDATE_TEACHER_COURSEOUTLINEREGISTRATION = gql`
  mutation updateTeacherCourseOutlineRegistration(
    $id: ID!,
    $courseOutlineId: ID!,
    $teacherId: ID!,
    $teacherCode: String!,
  ) {
    updateTeacherCourseOutlineRegistration (
      id: $id
      courseOutlineId: $courseOutlineId
      teacherId: $teacherId
      teacherCode: $teacherCode
    ) {
      id subjectCode subjectName teacherCode periodCode
      academicPeriod{
        id periodCode
      }
      courseOutline {
        id
      }
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSections {
        id sectionNo  descriptionLocal descriptionEng studentQty
        vdoSetCode startClassDate learnSpanNo examSpanNo
        vdoSet{
          id code description totalVdoLength
          vdoSetUnits {
            id unitSeq code totalVdoLength status remark
            vdoSetTopics {
              id no nameLocal nameEng vdoLength vdoStreamPath isEnabled
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const DELETE_COURSEOUTLINEREGISTRATION = gql`
  mutation deleteCourseOutlineRegistration(
    $id: ID!
  ) {
    deleteCourseOutlineRegistration (
      id: $id
    ) {
      id subjectCode subjectName teacherCode periodCode
      academicPeriod{
        id periodCode
      }
      courseOutline {
        id
      }
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSections {
        id sectionNo  descriptionLocal descriptionEng studentQty
        vdoSetCode startClassDate learnSpanNo examSpanNo
        vdoSet{
          id code description totalVdoLength
          vdoSetUnits {
            id unitSeq code totalVdoLength status remark
            vdoSetTopics {
              id no nameLocal nameEng vdoLength vdoStreamPath isEnabled
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

/* TYPES
input CourseOutlineRegistrationFilterInput {
  academicPeriodId: ID
  periodCode: String
  courseOutlineId: ID
  degreeId: ID
  subjectGroupId: ID
  subjectId: ID
  subjectCode: String
  teacherId: ID
  teacherCode: String
}

input CourseOutlineRegistrationInput {
  academicPeriodId: ID!
  periodCode: String
  courseOutlineId: ID!
  degreeId: ID!
  subjectGroupId: ID!
  subjectId: ID!
  subjectCode: String
  subjectName: String
  teacherId: ID!
  teacherCode: String
}

type CourseOutlineRegistration {
  id: ID!
  academicPeriod: AcademicPeriod!
  periodCode: String
  courseOutline: CourseOutline!
  degree: Degree!
  subjectGroup: SubjectGroup!
  subject: Subject!
  subjectCode: String
  subjectName: String
  teacher: Teacher!
  teacherCode: String
  classSections: [ClassSection]
  isDisabled: Boolean!
  createdAt: String!
  updatedAt: String!
  createdBy: User
  updatedBy: User
*/
